(function () {
  class Jq3xLightWorks extends HTMLElement {
    connectedCallback() {
      if (this.inited) return;
      this.inited = true;
      this.init();
    }

    disconnectedCallback() {
      this.destroy();
      this.inited = false;
    }

    init() {
      if (typeof Swiper === "undefined") return;

      this.diagram_el = this.querySelector("[data-jlw-diagram]");
      this.copy_el = this.querySelector("[data-jlw-copy]");
      this.preview_el = this.querySelector("[data-jlw-preview]");
      this.pages_el = this.querySelector("[data-jlw-pages]");
      this.pagination_el = this.querySelector("[data-jlw-pagination]");
      this.tabs_el = this.querySelector("[data-jlw-tabs]");
      this.tab_buttons = Array.from(this.querySelectorAll(".jq3x-light__tab"));
      this.mq = window.matchMedia("(max-width: 767px)");
      this.motion_mq = window.matchMedia("(prefers-reduced-motion: reduce)");
      this.speed = this.motion_mq.matches ? 0 : 450;
      this.active_index = 0;
      this.autoplay_enabled = this.dataset.autoplay === "true" && !this.motion_mq.matches;
      this.autoplay_delay = Math.max(1, Number(this.dataset.autoplayDelay || 5)) * 1000;
      this.pause_on_hover = this.dataset.pauseOnHover !== "false";
      this.hover_paused = false;
      this.hidden_paused = false;
      this.page_paused = false;

      this.init_wavelength();
      this.sync_pages();
      this.bind_media();
      this.bind_autoplay();
      this.start_autoplay();
    }

    bind_media() {
      this.on_mq_change = () => this.sync_pages();
      this.on_resize = () => {
        if (this.resize_raf) return;
        this.resize_raf = window.requestAnimationFrame(() => {
          this.resize_raf = null;
          if (this.mq.matches) this.equalize_pages();
        });
      };

      if (this.mq.addEventListener) {
        this.mq.addEventListener("change", this.on_mq_change);
      } else {
        this.mq.addListener(this.on_mq_change);
      }

      window.addEventListener("resize", this.on_resize, { passive: true });
    }

    init_wavelength() {
      const swiper_options = {
        slidesPerView: 1,
        spaceBetween: 0,
        speed: this.speed,
        allowTouchMove: false,
        nested: true,
        watchOverflow: true,
        observer: true,
        observeParents: true
      };

      if (this.diagram_el) {
        this.diagram_swiper = new Swiper(this.diagram_el, {
          ...swiper_options,
          effect: "fade",
          fadeEffect: { crossFade: true }
        });
      }

      if (this.copy_el) {
        this.copy_swiper = new Swiper(this.copy_el, {
          ...swiper_options,
          effect: "fade",
          fadeEffect: { crossFade: true },
          autoHeight: true
        });
      }

      this.bind_wavelength_events();
      this.sync_active(0);
    }

    bind_wavelength_events() {
      this.on_tab_click = (event) => {
        const index = Number(event.currentTarget.dataset.index || 0);
        this.go_to_index(index);
        this.start_autoplay();
      };

      this.tab_buttons.forEach((button) => {
        button.addEventListener("click", this.on_tab_click);
      });
    }

    bind_autoplay() {
      if (!this.autoplay_enabled) return;

      if (this.pause_on_hover && this.tabs_el) {
        this.on_pointer_enter = () => {
          this.hover_paused = true;
          this.stop_autoplay();
        };
        this.on_pointer_leave = () => {
          this.hover_paused = false;
          this.start_autoplay();
        };
        this.tabs_el.addEventListener("pointerenter", this.on_pointer_enter);
        this.tabs_el.addEventListener("pointerleave", this.on_pointer_leave);
      }

      this.on_visibility = () => {
        if (document.hidden) {
          this.stop_autoplay();
          return;
        }
        this.start_autoplay();
      };
      document.addEventListener("visibilitychange", this.on_visibility);

      if (typeof IntersectionObserver === "undefined") return;

      this.io = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          this.hidden_paused = !entry || !entry.isIntersecting;
          if (this.hidden_paused) {
            this.stop_autoplay();
          } else {
            this.start_autoplay();
          }
        },
        { threshold: 0.25 }
      );
      this.io.observe(this);
    }

    can_autoplay() {
      if (!this.autoplay_enabled) return false;
      if (this.hover_paused || this.hidden_paused || this.page_paused) return false;
      if (this.motion_mq && this.motion_mq.matches) return false;
      if (!this.tab_buttons || this.tab_buttons.length < 2) return false;
      if (document.hidden) return false;
      return true;
    }

    start_autoplay() {
      this.stop_autoplay();
      if (!this.can_autoplay()) return;

      this.autoplay_timer = window.setInterval(() => {
        if (!this.can_autoplay()) {
          this.stop_autoplay();
          return;
        }
        const next = (this.active_index + 1) % this.tab_buttons.length;
        this.go_to_index(next);
      }, this.autoplay_delay);
    }

    stop_autoplay() {
      if (!this.autoplay_timer) return;
      window.clearInterval(this.autoplay_timer);
      this.autoplay_timer = null;
    }

    sync_pages() {
      if (this.mq.matches) {
        this.destroy_preview();
        this.init_pages();
      } else {
        this.destroy_pages();
        this.init_preview();
      }
      this.start_autoplay();
    }

    init_preview() {
      if (this.preview_swiper || !this.preview_el) return;

      this.preview_swiper = new Swiper(this.preview_el, {
        slidesPerView: 1,
        spaceBetween: 0,
        speed: this.speed,
        allowTouchMove: false,
        nested: true,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        effect: "fade",
        fadeEffect: { crossFade: true }
      });

      if (this.active_index) {
        this.preview_swiper.slideTo(this.active_index, 0);
      }
    }

    destroy_preview() {
      if (!this.preview_swiper) return;
      this.preview_swiper.destroy(true, true);
      this.preview_swiper = null;
    }

    init_pages() {
      if (this.pages_swiper || !this.pages_el) return;
      if (!this.pagination_el) return;

      this.pages_swiper = new Swiper(this.pages_el, {
        slidesPerView: 1,
        spaceBetween: 16,
        speed: this.speed,
        rewind: true,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        pagination: {
          el: this.pagination_el,
          clickable: true
        },
        on: {
          slideChange: (swiper) => {
            this.page_paused = swiper.activeIndex !== 0;
            if (this.page_paused) {
              this.stop_autoplay();
            } else {
              this.start_autoplay();
            }
          }
        }
      });

      this.equalize_pages();
      this.bind_page_images();
      window.requestAnimationFrame(() => this.equalize_pages());
    }

    equalize_pages() {
      if (!this.pages_el || !this.mq.matches) return;

      const slides = Array.from(this.pages_el.querySelectorAll(".jq3x-light__page"));
      if (!slides.length) return;

      slides.forEach((slide) => {
        slide.style.minHeight = "";
      });

      let max_height = 0;
      slides.forEach((slide) => {
        if (slide.classList.contains("swiper-slide-duplicate")) return;
        max_height = Math.max(max_height, slide.offsetHeight);
      });

      if (!max_height) return;

      slides.forEach((slide) => {
        slide.style.minHeight = max_height + "px";
      });

      if (this.pages_swiper) this.pages_swiper.update();
    }

    bind_page_images() {
      if (!this.pages_el || this.on_page_images_load) return;

      this.on_page_images_load = () => this.equalize_pages();
      this.pages_el.querySelectorAll("img").forEach((img) => {
        if (img.complete) return;
        img.addEventListener("load", this.on_page_images_load, { once: true });
        img.addEventListener("error", this.on_page_images_load, { once: true });
      });
    }

    destroy_pages() {
      if (this.pages_el) {
        this.pages_el.querySelectorAll(".jq3x-light__page").forEach((slide) => {
          slide.style.minHeight = "";
        });
      }

      this.on_page_images_load = null;
      this.page_paused = false;

      if (!this.pages_swiper) return;
      this.pages_swiper.destroy(true, true);
      this.pages_swiper = null;
    }

    go_to_index(index) {
      if (this.is_syncing) return;
      this.is_syncing = true;
      this.active_index = index;

      if (this.diagram_swiper && this.diagram_swiper.activeIndex !== index) {
        this.diagram_swiper.slideTo(index);
      }
      if (this.copy_swiper && this.copy_swiper.activeIndex !== index) {
        this.copy_swiper.slideTo(index);
      }
      if (this.preview_swiper && this.preview_swiper.activeIndex !== index) {
        this.preview_swiper.slideTo(index);
      }

      this.sync_active(index);
      this.is_syncing = false;
    }

    sync_active(index) {
      this.tab_buttons.forEach((button, i) => {
        const is_active = i === index;
        button.classList.toggle("is-active", is_active);
        button.setAttribute("aria-selected", is_active ? "true" : "false");
      });
    }

    destroy() {
      this.stop_autoplay();

      if (this.io) {
        this.io.disconnect();
        this.io = null;
      }

      if (this.tabs_el && this.on_pointer_enter) {
        this.tabs_el.removeEventListener("pointerenter", this.on_pointer_enter);
        this.on_pointer_enter = null;
      }
      if (this.tabs_el && this.on_pointer_leave) {
        this.tabs_el.removeEventListener("pointerleave", this.on_pointer_leave);
        this.on_pointer_leave = null;
      }
      if (this.on_visibility) {
        document.removeEventListener("visibilitychange", this.on_visibility);
        this.on_visibility = null;
      }

      if (this.mq && this.on_mq_change) {
        if (this.mq.removeEventListener) {
          this.mq.removeEventListener("change", this.on_mq_change);
        } else {
          this.mq.removeListener(this.on_mq_change);
        }
      }

      if (this.on_resize) {
        window.removeEventListener("resize", this.on_resize);
      }

      if (this.tab_buttons && this.on_tab_click) {
        this.tab_buttons.forEach((button) => {
          button.removeEventListener("click", this.on_tab_click);
        });
      }

      if (this.diagram_swiper) {
        this.diagram_swiper.destroy(true, true);
      }
      if (this.copy_swiper) {
        this.copy_swiper.destroy(true, true);
      }

      this.destroy_preview();
      this.destroy_pages();

      this.diagram_swiper = null;
      this.copy_swiper = null;
    }
  }

  function mount_jq3x_light_works(root) {
    if (!root) return;

    const panels = root.matches("jq3x-light-works")
      ? [root]
      : Array.from(root.querySelectorAll("jq3x-light-works"));

    panels.forEach((panel) => {
      if (panel.inited) {
        panel.disconnectedCallback();
        panel.connectedCallback();
      }
    });
  }

  if (!customElements.get("jq3x-light-works")) {
    customElements.define("jq3x-light-works", Jq3xLightWorks);
  }

  document.addEventListener("shopify:section:load", (event) => {
    mount_jq3x_light_works(event.target);
  });

  document.addEventListener("shopify:block:select", (event) => {
    const panel = event.target.closest("jq3x-light-works");
    if (!panel) return;

    const slide_el = event.target.closest(".jq3x-light__copy-slide");
    if (slide_el) {
      const slides = Array.from(panel.querySelectorAll(".jq3x-light__copy-slide"));
      const index = slides.indexOf(slide_el);
      if (index >= 0) {
        panel.go_to_index(index);
        panel.start_autoplay();
      }
      if (panel.pages_swiper) {
        panel.pages_swiper.slideTo(0);
      }
      return;
    }

    if (event.target.closest(".jq3x-light__page--compare") && panel.pages_swiper) {
      panel.pages_swiper.slideTo(1);
    }
  });
})();
